import { ReactElement } from 'react';
import { Box, Stack } from '@mantine/core';
import { AvailabilityProviderCard } from './AvailabilityProviderCard';
import { ProviderAvailability } from '../Availability/types';
import { AvailabilityType } from '@bariendo/lib/scheduling';

interface AvailabilityListProps {
  onEditAvailability: (providerId: string, availabilityId: string, type: AvailabilityType) => void;
  providers: ProviderAvailability[];
  getOneTimeAvailability: (provider: ProviderAvailability, providerSchedule: string) => Promise<void>;
}

export function AvailabilityList({
  onEditAvailability,
  providers,
  getOneTimeAvailability,
}: AvailabilityListProps): ReactElement {
  return (
    <Box p="md" bg="white" h="100%" style={{ overflowY: 'auto' }}>
      <Stack gap="md">
        {providers.map((provider) => (
          <AvailabilityProviderCard
            key={provider.providerId}
            provider={provider}
            onEditAvailability={onEditAvailability}
            getOneTimeAvailability={getOneTimeAvailability}
          />
        ))}
      </Stack>
    </Box>
  );
}
